import { render } from "./demoGame.vue?vue&type=template&id=e973e7b2&scoped=true"
import script from "./demoGame.vue?vue&type=script&lang=js"
export * from "./demoGame.vue?vue&type=script&lang=js"

import "./demoGame.vue?vue&type=style&index=0&id=e973e7b2&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e973e7b2"]])

export default __exports__